// NineSquareGrid.js (已修改)

import React, { useRef, useState } from 'react';
import { ImageViewer } from 'antd-mobile'
import './css/NewCommunity.css'; // 注意：导入的是 LESS 编译后的 CSS
import Image from '../../lib/Image';

/**
 * 九宫格图片显示组件 (兼容 4 张图片 2x2 布局，且图片大小与 3x3 保持一致)
 *
 * @param {object} props
 * @param {string[]} props.images - 图片 URL 数组，最多只取前 9 张
 * @returns {JSX.Element}
 */
const NineSquareGrid = ({ images }) => {

  const [visible, setVisible] = useState(false)
  const ref = useRef()

  // 原始图片数组，用于获取总数
  const originalImages = images || [];
  // 实际用于网格渲染的图片 (最多 9 张)
  const gridImages = originalImages.slice(0, 9);

  const totalCount = originalImages.length;
  const renderedCount = gridImages.length;

  // 1. 定义外层 wrapper 的类名，控制整体宽度
  let wrapperClasses = ['nine-square-wrapper'];
  if (renderedCount === 4) {
    wrapperClasses.push('wrapper-2x2-size');
  } else {
    wrapperClasses.push('wrapper-3x3-size');
  }

  // 2. 定义内层 grid 的类名，控制内部排列
  let gridClasses = ['nine-square-grid'];
  if (renderedCount === 4) {
    gridClasses.push('layout-2x2');
  } else {
    gridClasses.push('layout-3x3');
  }

  return (
    <div style={{ paddingTop: originalImages.length > 0 ? '15px' : '0' }}>
      <div className={wrapperClasses.join(' ')}>
        <div className={gridClasses.join(' ')}>
          {gridImages.map((item, index) => {
            const isLastItem = index === renderedCount - 1;

            return (
              <div
                key={index}
                className={`grid-item ${isLastItem ? 'last-item' : ''}`}
                onClick={e => {
                  e.stopPropagation();
                  e.preventDefault();
                  setVisible(true);
                  ref.current.swipeTo(index, false);
                }}
              >
                <Image
                  src={item.thumb}
                  alt={`Grid image ${index + 1}`}
                  loading="lazy"
                  className="grid-image"
                />

                {isLastItem && originalImages.length > 9 && (
                  <div className="count-overlay">
                    <img src="resources/251009/number.png" alt="" style={{ height: 11, marginRight: 3 }} />
                    <div>{totalCount}</div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
      <ImageViewer.Multi
        ref={ref}
        classNames={{
          mask: 'community-image-viewer',
        }}
        getContainer={document.getElementById('root')}
        images={originalImages.map(e => e.source)}
        visible={visible}
        defaultIndex={0}
        onClose={() => {
          setVisible(false)
        }}
      />
    </div>
  );
};

export default NineSquareGrid;